import React, { useEffect, useState } from 'react';
import { useHistory } from 'react-router';
import FullCalendar from '@fullcalendar/react'; // must go before plugins
import dayGridPlugin from '@fullcalendar/daygrid'; // a plugin!
import styles from './calendar.module.scss';
import roLocale from '@fullcalendar/core/locales/ro';
import { getCalendar, getLitigii } from '../../network/litigii';
import { ROUTES } from '../../routing/routes';

const Calendar = () => {
  const history = useHistory();

  const [events, setEvents] = useState<any>();
  const getCalendarList = (filter?: any) => {
    // setLoading(true);
    getCalendar().then(({ data }) => {
      console.log(data);
      for (const row of data.rows) {
        row.allDay = true;
      }
      setEvents(data.rows);
    });
  };

  useEffect(() => {
    getCalendarList();
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.rowInfo}>
          <div className='column align-start fullWidth'>
            <p className='subheading-dark bold'>Calendar termene</p>
          </div>
        </div>

        <div className={styles.calendar}>
          <FullCalendar
            locale={roLocale}
            plugins={[dayGridPlugin]}
            initialView='dayGridMonth'
            weekends={true}
            events={events}
            eventClick={info => {
              history.push(ROUTES.LITIGII + '/' + info.event.id);
            }}
          />
        </div>
      </div>
    </div>
  );
};

export default Calendar;
